// src/world/maps/villaAurelia.ts — Villa Aurelia 30x24
import { parseLayout } from '../tiles.js';
import type { ZoneId } from '../../data/gameConfig.js';

export const VILLA_SIZE = { w: 30, h: 24 };

const LAYOUT: string[] = [
  // 0         1         2
  // 012345678901234567890123456789
  "TTTTTTTTTTTTTTTTTTTTTTTTTTTTTT", // 0
  "TGGGGGGGGGGGGGGGGGGGGGGGGGGGGT", // 1
  "TGGGGGGGGGGGGPPPPPPGGGGGGGGGGT", // 2  camino norte
  "TGGfGGGMMMGGGGPGGPGGGGMMMGfGGGT", // 3  casa jugador (6,3) tienda (20,3)
  "TGGGGGGMFFMGGGPGGPGGGMFFFFMGGGT", // 4
  "TGfFGGGMFFMGGGPGGPGGGMFFFFMGGfT", // 5
  "TGGGGGGMMMGGGGPGGPGGGGMMMGGGGGT", // 6
  "TGGGGGGGGGGGGPGGPGGGGGGGGGGGGT", // 7
  "TGGGGfGGGGGGGPGGPGGGGGGGGfGGGT", // 8  door tienda en (22,8) = P sobre borde? ajustamos
  "TGGGGGGGGGGGGPGGPGGGGGGGGGGGGT", // 9
  "TGGGGGGGGGGAAPAAAGGGGGGGGGGGGT", //10 plaza empieza
  "TGGGGGGGGGAAFfAAfGGGGGGGGGGGGT", //11
  "TGGGGGGGGGAAFAAAGGGGGGGGGGGGGT", //12 fuente en (14,12) F
  "TGGGGGGGGGAAFAAAGGGGGGGGGGGGGT", //13
  "TGGGGGGGGGAAFfAAGGGGGGGGGGGGGT", //14 plaza termina
  "TGGGGGGGGGGPPPPPPGGGGGGGGGGGGT", //15 camino medio
  "TGGGGfGMMMGGGPGGPGGGMMMGGGGfGT", //16 centro/casa NPC fila
  "TGGGGGGMFFMGGPGGPGGMFFMGGGGGGT", //17
  "TGfGGGGMFFMGGPGGPGGMFFMGGGfGGT", //18
  "TGGGGGGMMMGGGPGGPGGGMMMGGGGGGT", //19 doors en (9,19) y (21,19)
  "TGGGGGGGGGGGPGGPGGGGGGGGGGGGT", //20
  "TGGfGGGRGGGGPGGPGGGGRGGGGfGGGT", //21 rocas deco
  "TGGGGGGGGGGGPGGPGGGGGGGGGGGGT", //22 salida sur
  "TTTTTTTTTTTTPPPPPPPTTTTTTTTTTT", //23 borde sur con apertura
];

// Post-proceso: colocar puertas y detalles específicos que no encajan en char layout
function build(): number[][] {
  const map = parseLayout(LAYOUT);
  // Ajustar puertas: villa doors son tiles 7 sobre camino/plaza
  // Casa jugador puerta sur (7,6?) según layout: casa en (6,3)-(9,6), puerta en (7,6?) -> usamos (7,7) como transición
  map[6][7] = 7; // casa jugador puerta (x 7, y 6) → índice [6][7]
  map[8][22] = 7; // tienda puerta (22,8)
  map[19][9] = 7; // centro puerta (9,19)
  map[19][21] = 7; // casa npc puerta (21,19)
  // Entrada sur a Ruta: bottom edge (14,23) y (15,23) son path -> warp
  map[23][14] = 7; map[23][15] = 7;
  // Fuente plaza: centro (14,12) marcar como plaza deco especial (ya plaza 14, pero pondremos flower para fuente)
  map[12][14] = 8; // fuente decorativa
  map[12][15] = 8;
  // Añadir rocas/water deco alrededor
  map[21][8] = 11; map[21][21] = 11;
  // Árboles grandes en esquinas interiores
  map[2][2] = 5; map[2][27] = 5; map[20][2] = 5; map[20][27] = 5;
  return map;
}

export const VILLA_AURELIA_MAP = build();

// Warps dentro de Villa Aurelia: puerta → interior zone
export type Warp = { x: number; y: number; to: ZoneId; toX: number; toY: number; facing?: 'north'|'south'|'east'|'west' };

export const VILLA_WARPS: Warp[] = [
  { x: 7,  y: 6, to: 'casa_jugador',   toX: 6, toY: 8, facing: 'north' },
  { x: 22, y: 8, to: 'tienda_aurelia', toX: 6, toY: 8, facing: 'north' },
  { x: 9,  y: 19,to: 'centro_aurelia', toX: 6, toY: 8, facing: 'north' },
  { x: 21, y: 19,to: 'casa_npc',       toX: 6, toY: 8, facing: 'north' },
  // Salida sur → Ruta Aurelia (entrada norte de ruta)
  { x: 14, y: 23, to: 'ruta_aurelia', toX: 16, toY: 1, facing: 'south' },
  { x: 15, y: 23, to: 'ruta_aurelia', toX: 16, toY: 1, facing: 'south' },
];

// Posiciones de carteles/objetos interactivos (no NPC)
export type SignDef = { x:number; y:number; text:string[] };
export const VILLA_SIGNS: SignDef[] = [
  { x: 14, y: 9,  text: ["VILLA AURELIA", "Fundada bajo la primera aurora.", "Población: acogedora. Secretos: varios."] },
  { x: 5,  y: 10, text: ["Casa del Explorador", "Tu hogar. Tu madre dejó una nota en la mesa."] },
  { x: 24, y: 10, text: ["Bazar de Liora", "Todo para el viaje. ¡Pregunta por los cristales!"] },
  { x: 5,  y: 15, text: ["Centro de Descanso", "Aquí tus Asterias descansan. Habla con Solea."] },
  { x: 14, y: 12, text: ["Fuente de la Aurora", "Dicen que si arrojas un cristal, la fuente susurra tu futuro."] },
  { x: 14, y: 22, text: ["→ Ruta Aurelia", "Al sur, la aventura. Al norte, el hogar."] },
];
